// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g5-0";
export var actionModalContentContainer = "_g5-1";
export var createTagButton = "_g5-2";
export var footerContainer = "_g5-7";
export var fullWidthDivider = "_g5-3";
export var hasCreateTagButton = "_g5-4";
export var noCreateTagButton = "_g5-5";
export var tagsContainer = "_g5-6";
export var tagsModalContentContainer = "_g5-8";